module.exports = __webpack_public_path__ + "static/media/Circo2025_07.c70d1293.webp";